// AdminScontistiche.jsx
import React, { useState, useEffect } from "react";
import { db } from "./firebase.js";
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";
import "./AdminScontistiche.css";

// Cloudinary config
const CLOUD_NAME = "do82etc8l";
const UPLOAD_PRESET = "webapp_eventi"; // puoi creare uno specifico "webapp_scontistiche" se vuoi

export default function AdminScontistiche() {
  const [sconti, setSconti] = useState([]);
  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    nome: "",
    descrizione: "",
    logoUrl: "", // per URL
  });

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const [imgMethod, setImgMethod] = useState("file"); // "file" o "url"

  // fetch sconti
  const fetchSconti = async () => {
    setLoading(true);
    try {
      const snapshot = await getDocs(collection(db, "scontistiche"));
      setSconti(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error("Errore fetch sconti:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSconti();
  }, []);

  // upload su Cloudinary
  const uploadToCloudinary = async (file) => {
    if (!file) return null;
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", UPLOAD_PRESET);

    const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
      method: "POST",
      body: data,
    });

    const txt = await res.text();
    if (!res.ok) throw new Error("Upload Cloudinary fallito: " + txt);

    const json = JSON.parse(txt);
    return json.secure_url;
  };

  // submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nome || (!file && imgMethod === "file") || (!form.logoUrl && imgMethod === "url")) {
      return alert("Nome e immagine obbligatori");
    }

    try {
      let logo = "";

      if (imgMethod === "file") {
        logo = await uploadToCloudinary(file);
      } else {
        logo = form.logoUrl.trim();
      }

      await addDoc(collection(db, "scontistiche"), {
        nome: form.nome,
        descrizione: form.descrizione,
        logo,
        createdAt: Date.now(),
      });

      alert("Scontistica aggiunta!");
      setForm({ nome: "", descrizione: "", logoUrl: "" });
      setFile(null);
      setPreview(null);
      fetchSconti();
    } catch (err) {
      console.error(err);
      alert("Errore: " + (err.message || err));
    }
  };

  // elimina
  const handleDelete = async (id) => {
    if (!window.confirm("Eliminare scontistica?")) return;
    try {
      await deleteDoc(doc(db, "scontistiche", id));
      setSconti(prev => prev.filter(s => s.id !== id));
    } catch (err) {
      console.error(err);
      alert("Errore eliminazione");
    }
  };

  // preview
  const handleFile = (f) => {
    if (f) {
      setFile(f);
      setPreview(URL.createObjectURL(f));
    } else {
      setFile(null);
      setPreview(null);
    }
  };

  return (
    <div className="admin-scontistiche-container">
      <h1 className="admin-scontistiche-title">Gestione Scontistiche (Admin)</h1>

      <form className="admin-scontistiche-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Nome attività"
          value={form.nome}
          onChange={(e) => setForm({ ...form, nome: e.target.value })}
        />
        <textarea
          placeholder="Descrizione sconto"
          value={form.descrizione}
          onChange={(e) => setForm({ ...form, descrizione: e.target.value })}
        />

        <div>
          <label>
            <input
              type="radio"
              name="imgMethod"
              value="file"
              checked={imgMethod === "file"}
              onChange={() => setImgMethod("file")}
            /> Carica file
          </label>
          <label>
            <input
              type="radio"
              name="imgMethod"
              value="url"
              checked={imgMethod === "url"}
              onChange={() => setImgMethod("url")}
            /> Inserisci URL
          </label>
        </div>

        {imgMethod === "file" ? (
          <>
            <input type="file" accept="image/*" onChange={(e) => handleFile(e.target.files[0])} />
            {preview && <img src={preview} alt="preview" className="preview" />}
          </>
        ) : (
          <input
            type="text"
            placeholder="URL logo"
            value={form.logoUrl}
            onChange={(e) => setForm({ ...form, logoUrl: e.target.value })}
          />
        )}

        <button type="submit" className="admin-button">Aggiungi Scontistica</button>
      </form>

      <h2>Scontistiche esistenti</h2>
      {loading ? <p>Caricamento...</p> : (
        <div className="admin-scontistiche-list">
          <table>
            <thead>
              <tr>
                <th>Logo</th>
                <th>Nome</th>
                <th>Descrizione</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {sconti.map(s => (
                <tr key={s.id}>
                  <td>
                    {s.logo && <img src={s.logo} alt={s.nome} className="preview-small" />}
                  </td>
                  <td>{s.nome}</td>
                  <td>{s.descrizione}</td>
                  <td>
                    <button className="edit-btn" onClick={() => {
                      setForm({ nome: s.nome, descrizione: s.descrizione, logoUrl: s.logo });
                      setPreview(s.logo);
                      setImgMethod("url");
                    }}>Modifica</button>
                    <button className="delete-btn" onClick={() => handleDelete(s.id)}>Elimina</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
